import { size } from "../../constants";
import { useTheme } from "../../contexts/ThemeContext";
import { useWindowSize } from "../../hooks/useWindowResize";
import { HamburguerMenuImage } from "../assets/hamburguer-menu";

import { useTranslation } from "next-i18next";
import { StaticI18nLink } from "../Link";

import {
	NavbarCustom,
	NavbarContainer,
	BrandImage,
	ToggleThemeBtn,
	NavbarToggle,
	NavbarCollapse,
	HeaderLoginButton,
} from "./styles/Topbar.styles";

export function Topbar({
	defaultTheme,
	showTheme = true,
	children,
	isTransparent = false,
}) {
	const { theme: hookTheme, toggleTheme } = useTheme();
	const theme = defaultTheme || hookTheme;

	const { width } = useWindowSize();
	const { t } = useTranslation();

	return (
		<NavbarCustom
			expand="lg"
			fixed="top"
			className={`px-0 ${isTransparent ? "transparent" : ""} ${theme === "dark" ? "dark" : "light"}`}
		>
			<NavbarContainer>
				<StaticI18nLink href="/" className="p-0 m-0 navbar-brand-link">
					<a>
						<BrandImage
							src={
								theme === "dark"
									? "/landings/assets/images/logo_icon_verzel_white.svg"
									: "/blog/assets/svg/logo-horizontal-black.svg"
							}
							alt="Logo verzel"
						/>
					</a>
				</StaticI18nLink>

				<div className="content">
					{width < size.laptop && (
						<>
							{showTheme && (
								<ToggleThemeBtn type="button" onClick={() => toggleTheme()}>
									{theme === "light" ? (
										<img
											src="/blog/assets/svg/theme/moon.svg"
											alt="Dark mode"
										/>
									) : (
										<img
											src="/blog/assets/svg/theme/sun-dim.svg"
											alt="Light mode"
										/>
									)}
								</ToggleThemeBtn>
							)}
							<NavbarToggle aria-controls="navbar-nav">
								<HamburguerMenuImage
									color={theme === "dark" ? "#fff" : "#000"}
								/>
							</NavbarToggle>
						</>
					)}
					<NavbarCollapse id="navbar-nav">{children}</NavbarCollapse>

					<HeaderLoginButton
						showTheme={showTheme}
						outline={theme === "dark"}
						variant="neutral"
						rel="noopener noreferrer nofollow"
						target="_blank"
						href="https://v3.verzel.com.br/auth/login"
					>
						{t("header.login")}
					</HeaderLoginButton>

					{width >= size.laptop && showTheme && (
						<ToggleThemeBtn type="button" onClick={() => toggleTheme()}>
							{theme === "light" ? (
								<img src="/blog/assets/svg/theme/moon.svg" alt="Dark mode" />
							) : (
								<img
									src="/blog/assets/svg/theme/sun-dim.svg"
									alt="Light mode"
								/>
							)}
						</ToggleThemeBtn>
					)}
				</div>
			</NavbarContainer>
		</NavbarCustom>
	);
}
